import React from 'react';
import { Table } from '@zillow/constellation';
import { IOldTransactionResponse } from '../../../../../types/order/escrow/response/IOldTransactionResponse';
import { DateFormat, getDateString } from '../../../../../ui-toolkit/utilities/getDateString';
import { currencyDisplay } from '../../../../../utilities/shared/currencyDisplay';
import { getEscrowBankAccountLabel } from '../../../../../ui-toolkit/utilities/getEscrowBankAccountLabel';
import { useHasFeatureFlag } from '../../../../../selectors/useHasFeatureFlag';

export const OldTransactionRow: React.FC<{
  item: IOldTransactionResponse
}> = ({ item }) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  return (
    <Table.Row>
      <Table.Cell>{item.transactionType}</Table.Cell>
      <Table.Cell>{item.transactionMethod}</Table.Cell>
      <Table.Cell>{item.description}</Table.Cell>
      <Table.Cell>{currencyDisplay(item.amountCents, true)}</Table.Cell>
      <Table.Cell>{item.category}</Table.Cell>
      <Table.Cell>{item.memo}</Table.Cell>
      <Table.Cell>{item.currentPeriod}</Table.Cell>
      <Table.Cell>{item.issuedAt && getDateString(DateFormat.hugeDate, item.issuedAt)}</Table.Cell>
      <Table.Cell>{item.clearedAt && getDateString(DateFormat.hugeDate, item.clearedAt)}</Table.Cell>
      <Table.Cell>{item.bankAccountResponse && getEscrowBankAccountLabel(item.bankAccountResponse, isSpruceWithZillowEnabled, isZillowClosingEnabled)}</Table.Cell>
      <Table.Cell>{item.bankAccountResponse?.accountNumber}</Table.Cell>
    </Table.Row>
  );
};
